import { FEEDBACK_EMAIL } from '../constants';

const openEmailDraft = ({ subject, name, email, comment }) => {
  const mailtoLink = `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
    `Name: ${name}\nEmail: ${email}\n${comment}\n`
  )}`;

  window.location.href = mailtoLink;
};

export const signUp = ({ name, email, phone, company, notes }) => {
  const subject = 'AdTools: New User Sign Up Request';
  const comment = `Phone: ${phone}\nCompany: ${company}\nNotes:\n${notes ?? ''}`;

  return openEmailDraft({
    subject,
    name,
    email,
    comment,
  });
};

export const submitFeedback = ({ name, email, mobile, company, feedback }) => {
  const subject = 'Ad Tools Feedback';
  const comment = `Phone: ${mobile ?? ''}\nCompany: ${company ?? ''}\nFeedback:\n${feedback}`;

  return openEmailDraft({
    subject,
    name,
    email,
    comment,
  });
};
